function getCurrency() {
  const hostname = location.hostname;
  switch (hostname) {
    case "www.beginningboutique.co.nz":
      return "NZD";
    case "www.beginningboutique.com.au":
      return "AUD";
    case "www.beginningboutique.com":
      return "USD";
    default:
      return "";
  }
}

function generateItemListSchema() {
  // Check if the script is already present
  const container = document.querySelector("#ns-product-grid");
  if (!container) return;

  // Check if the collection have no products
  const noProduct = container.querySelector(".ss-no-results-container");
  if (noProduct) return;

  const productCards = container.querySelectorAll(".ns-product");
  if (!productCards.length) return;

  const priceCurrency = getCurrency();

  let itemList = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: Array.from(productCards).map((card, index) => {
      const titleEl = card.getAttribute("aria-label");
      const productUrl = card.querySelector(".ns-details > a");
      const imageEl = card.querySelector(".ns-img");
      const priceEl = card.querySelector(".ns-details .ns-price");

      let price = "";
      if (priceEl) {
        price = priceEl.textContent.trim();
        price = price.replace(/^\$/, "");
      }

      const ratingElement = card.querySelector(".sr-only");
      const ratingText = ratingElement ? ratingElement.textContent.trim() : "";
      const ratingMatch = ratingText.match(/[\d.]+/);
      const rating = ratingMatch ? parseFloat(ratingMatch[0]) : 4.5;

      const reviewsElement = card.querySelector(`a.text-m[href="javascript:void(0)"]`);
      const reviewsMatch = reviewsElement ? reviewsElement.textContent.match(/\d+/) : null;
      const reviews = reviewsMatch ? parseInt(reviewsMatch[0]) : 1;

      if (
        !titleEl ||
        !productUrl.href ||
        !imageEl.src ||
        !price ||
        !priceCurrency ||
        !rating ||
        rating < 1 ||
        rating > 5
      ) {
        return null;
      }

      return {
        "@type": "ListItem",
        position: index,
        item: {
          "@type": "Product",
          name: titleEl || "",
          url: productUrl ? productUrl.href : "",
          image: imageEl ? imageEl.src : "",
          offers: {
            "@type": "Offer",
            url: titleEl ? titleEl.href : "",
            price: price,
            priceCurrency: priceCurrency,
            priceValidUntil: "12-12-2030",
            availability: "https://schema.org/InStock",
          },
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: rating,
            bestRating: ratingMatch ? 5 : 4.5,
            ratingCount: reviews,
          },
        },
      };
    }),
  };

  itemList = {
    ...itemList,
    itemListElement: itemList.itemListElement.filter((item) => item),
  };
  if (!itemList.itemListElement.length) return;

  console.log("itemList", itemList);
  const oldScript = document.getElementById("schema-itemlist");
  if (oldScript) oldScript.remove();

  const script = document.createElement("script");
  script.id = "schema-itemlist";
  script.type = "application/ld+json";
  script.textContent = JSON.stringify(itemList, null, 2);
  document.head.appendChild(script);
}

let attempts = 0;
const interval = setInterval(() => {
  generateItemListSchema();
  attempts++;
  if (document.querySelector("#schema-itemlist") || attempts >= 10) {
    clearInterval(interval);
  }
}, 500);
